import { getCurrentLanguage } from './i18nUtils';

export const formatAsDate = (date) => {
  return date.toLocaleDateString(getCurrentLanguage());
};
